import { AuthenticatorType } from '@mews-commander/data-access';
import { UnsavedChangesDialog } from '@mews-commander/ui';
import { useDialog } from '@mews/framework';
import { Configure2FAPanelDevice } from './Configure2FAPanelDevice/Configure2FAPanelDevice';
import { Configure2FAPanelSelectMethod } from './Configure2FAPanelSelectMethod';
import { Configure2FAPanelValidateCode } from './Configure2FAPanelValidateCode';
import { Configure2FAPanelRoutes, useConfigure2FAPanel } from './useConfigure2FAPanel';

const authenticatorTypeRouteMap = {
    [AuthenticatorType.Google]: Configure2FAPanelRoutes.deviceConfig,
    [AuthenticatorType.Email]: Configure2FAPanelRoutes.emailConfig,
    [AuthenticatorType.None]: Configure2FAPanelRoutes.selectMethod,
};

export function Configure2FAPanel() {
    const { close2FAPanel, activeRoute, change2FARoute } = useConfigure2FAPanel();
    const [{ active: unsavedDialogActive, onClose: handleUnsavedDialogCancel }, openUnsavedDialog] = useDialog();

    const routePropsMap = {
        [Configure2FAPanelRoutes.selectMethod]: (
            <Configure2FAPanelSelectMethod
                onSelectRoute={(authenticatorType) => change2FARoute(authenticatorTypeRouteMap[authenticatorType])}
                onClose={openUnsavedDialog}
            />
        ),
        [Configure2FAPanelRoutes.deviceConfig]: (
            <Configure2FAPanelDevice
                onClose={openUnsavedDialog}
                onSubmit={close2FAPanel}
                onReturn={() => change2FARoute(Configure2FAPanelRoutes.selectMethod)}
            />
        ),
        [Configure2FAPanelRoutes.emailConfig]: (
            <Configure2FAPanelValidateCode
                onClose={openUnsavedDialog}
                type={AuthenticatorType.Email}
                onSubmit={close2FAPanel}
                onReturn={() => change2FARoute(Configure2FAPanelRoutes.selectMethod)}
            />
        ),
    };

    return (
        <>
            {activeRoute && routePropsMap[activeRoute]}
            <UnsavedChangesDialog
                active={unsavedDialogActive}
                onCancel={handleUnsavedDialogCancel}
                onDiscardChanges={() => {
                    handleUnsavedDialogCancel();
                    close2FAPanel();
                }}
            />
        </>
    );
}
